import { render, staticRenderFns } from "./MolliePayment.vue?vue&type=template&id=5ef949cd&scoped=true&"
import script from "./MolliePayment.vue?vue&type=script&lang=ts&"
export * from "./MolliePayment.vue?vue&type=script&lang=ts&"
import style0 from "./MolliePayment.vue?vue&type=style&index=0&id=5ef949cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef949cd",
  null
  
)

export default component.exports